import {
  type TLeadsOptions,
  type TLeadsPatch,
  type TResponseLeads,
  type TSingleLead
} from '@/components/App/Leads/types';

import { ApiConnector } from '../api.connector';

class LeadApi extends ApiConnector {
  startBadgeLeads(): Promise<number> {
    return this.call({ path: 'leads/count/newCount' });
  }

  getLeads(searchOptionsDto: TLeadsOptions): Promise<TResponseLeads> {
    return this.call({
      path: 'leads',
      method: 'get',
      params: searchOptionsDto
    });
  }

  /**
   * Получить лид по идентификатору.
   * GET /leads/:requestId
   */
  getLeadById(requestId: string): Promise<TSingleLead> {
    return this.call({ path: `leads/${requestId}`, method: 'get' });
  }

  /**
   * Обновить лид по идентификатору.
   * PATCH /leads/:requestId
   *
   * @param requestId Идентификатор лида.
   * @param data Данные для обновления, типизированные как UpdateLeadsDto.
   */
  patchLead(requestId: string, data: TLeadsPatch): Promise<unknown> {
    return this.call({
      path: `leads/${requestId}`,
      method: 'patch',
      body: data
    });
  }
}

export const leadApi = new LeadApi();
